import { createFileRoute } from '@tanstack/react-router';
import ComingSoonCover from '@/components/ComingSoonCover';
export const Route = createFileRoute('/_staff/settings/contracting-corporation-profile/_layout/contact-points/')({
  component: ContactPointsComingSoon
});
function ContactPointsComingSoon() {
  return <ComingSoonCover disableBlurBackdrop={true} />;
}